import React from "react";

const ArticleCreateStep5 = ({ status }) => {
  const isFailed = status === "failed";

  return (
    <div className="article_success_wrapper">
      <div className="article_success_card">
        <div className="success_icon">{isFailed ? "✕" : "✓"}</div>

        <h2 className="success_title">
          {isFailed
            ? "Le paiement n'a pas abouti"
            : "Annonce publiée avec succès !"}
        </h2>

        <p className="success_description">
          {isFailed
            ? "Le paiement a échoué ou a été annulé. Vous pouvez réessayer ou choisir un autre moyen de paiement."
            : "Félicitations 🎉 Votre annonce est maintenant en ligne et visible par des milliers d'utilisateurs."}
        </p>

        <div className="success_actions">
          {isFailed ? (
            <button
              className="article_success_btn_primary"
              onClick={() => (window.location.href = "/article/creation")}
            >
              Réessayer le paiement
            </button>
          ) : (
            <>
              <button
                className="article_success_btn_primary"
                onClick={() =>
                  (window.location.href = "/utilisateur/mesAnnonces/")
                }
              >
                Voir mon annonce
              </button>

              <button
                className="article_success_btn_secondary"
                onClick={() => (window.location.href = "/article/creation")}
              >
                Publier une autre annonce
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ArticleCreateStep5;
